const emailRegex =
  /^(?=[A-Z0-9][A-Z0-9@._-]{5,253}$)[A-Z0-9._-]{1,64}[A-Z0-9]@(?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8}[A-Z]{2,63}$/iu;

export default emailRegex;
